module.exports = __webpack_public_path__ + "assets/img/calculator.9121a289.svg";